<template>
    <div class>
        <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
            <span style="font-weight:600;color:#000; line-height: 10px;">运营商信息</span>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="width: 400px; margin-top: 20px;">
            <el-form-item label="方案名称" prop="projectName">
                <el-input
                v-model="form.projectName"
                placeholder="请输入方案名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="承担方" prop="responsible">
                <el-radio-group v-model="form.responsible">
                    <el-radio :label="0" >平台</el-radio>
                    <el-radio :label="1" >加盟运营商</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="运营商" prop="operator">
                <el-input
                v-model="form.operator"
                placeholder="请输入运营商"
                ></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="date">
                <el-date-picker
                    v-model="form.date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" 
                    @change="handleChange"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="活动周天" prop="checkList" style="width: 700px;">
                <el-checkbox-group v-model="form.checkList">
                    <el-checkbox v-for="item in weekOptions" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="活动介绍" prop="recommend" style="width: 600px;">
                <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入广告内容"
                v-model="form.recommend"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
            <span style="font-weight:600;color:#000; line-height: 10px;"> 活动配置</span>
        </div>
        <el-form :model="lastform" :rules="lastrules" ref="lastform"  style="margin-top: 20px;">
            <el-form-item label="价格时区" prop="pricingModel" label-width="120px">
                <!-- <el-select
                    v-model="lastform.pricingModel"
                    placeholder="请选择价格区间"
                    @change="selectPrice"
                >
                    <el-option
                        v-for="(item, index) in priceList"
                        :key="index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select> -->
                <div>{{lastform.pricingModel}}</div>
            </el-form-item>
            <el-form-item label="优惠类型" prop="discountType" label-width="120px">
                <el-radio-group v-model="lastform.discountType" @change="selectText">
                    <el-radio :label="1" >一口价优惠</el-radio>
                    <el-radio :label="2" >折扣优惠</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="优惠配置" label-width="120px">
                <el-table
                    :data="tableData"
                    border
                    style="width: 660px;">
                    <el-table-column
                        align="center"
                        label="时区"
                        width="150">
                    <template slot-scope="scope">
                        <div>{{scope.row.priceStartPeriod}} - {{scope.row.priceEndPeriod}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    :label="priceText"
                    width="180">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.cpoElecMoney"
                            @change="changePrice(scope.row, scope.$index)"
                        ></el-input>
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    :label="serviceText"
                    width="180">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.cpoServiceMoney"
                            @change="changePrice(scope.row, scope.$index)"
                        ></el-input>
                    </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="priceType"
                        label="价格类别"
                        width="150">
                    </el-table-column>
                </el-table>
                <span style="color: #2593FC">温馨提示：修改某一价格列表的电费与服务费单价时，所有相同价格类别单价将统一修改，如不设置单价则保持电站原价</span>
            </el-form-item>

            <el-form-item label="选择运营商" prop="discountSiteList" label-width="120px">
                <STree v-model="lastform.discountSiteList" :data="discountTree" style="width:400px;"></STree>
            </el-form-item>
            <el-form-item label="选择城市" prop="discountSiteList" label-width="120px">
                <STree v-model="lastform.discountSiteList" :data="cityTree" style="width:400px;"></STree>
            </el-form-item>
            <el-form-item label="活动用户" prop="userID" label-width="120px">
                <STree v-model="lastform.userID" :data="userTree" style="width:400px;"></STree>
            </el-form-item>
        </el-form>
        <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
        </div>
    </div>
</template>
  
<script>
import { HOST, EV_HOST } from "@/utils/host";
const token = window.localStorage.getItem("token");
export default {
    name: "xinzengyouhuifangan",
    components: {},
    data() {
      return {
        weekOptions :[
          {label: '周日', value: '1'},
          {label: '周一', value: '2'}, 
          {label: '周二', value: '3'},
          {label: '周三', value: '4'},
          {label: '周四', value: '5'},
          {label: '周五', value: '6'},
          {label: '周六', value: '7'},
        ],
        form: {
            projectName: "",
            responsible: 0,
            operator: "",
            date: [],
            checkList:[],
            recommend: ""
        },
        rules: {},
        lastform: {
            discountType: 1,
            pricingModel: "",
            discountSiteList: [],
            userID: []
        },
        rowdata: {},
        priceList: [],
        tableData: [],
        lastrules: {},
        discountTree: [],
        userTree: [],
        cityTree: [],
        priceText: "电费（元/度）",
        serviceText: "服务费（元/度）",
        id: {}
      };
    },
    computed: {
      headers() {
        // console.log(token);
        return {
          token: token
        };
      },
      
    },
    methods: {
        cancel() {
            this.$router.go(-1);
        },
        save() {
            let weekList = this.form.checkList.join(",")
            let discountStartDay = this.form.date[0]
            let discountEndDay = this.form.date[1]
            let discountSite = this.lastform.discountSiteList.join(",")
            let userId = this.lastform.userID.join(",")
            let data = {
                projectName: this.form.projectName,
                responsible: this.form.responsible,
                operator: this.form.operator,
                discountWeek: weekList,
                discountStartDay: discountStartDay,
                discountEndDay: discountEndDay,
                recommend: this.form.recommend,
                discountSite: discountSite,
                userId: userId,
                discountType: this.lastform.discountType.toString(),
                pricingModel: this.lastform.pricingModel,
                timeZone: this.tableData,
                id: this.id
            }
            this.$store.dispatch("form/handle", {
                url: "/business/discountterm/put",
                data: data,
                method: "put",
                callback: resp => {
                this.$router.go(-1);
              }
            });
        },
        handleChange(value) {
            this.form.checkList = []
            this.weekOptions=[
              {label: '周日', value: '1'},
              {label: '周一', value: '2'}, 
              {label: '周二', value: '3'},
              {label: '周三', value: '4'},
              {label: '周四', value: '5'},
              {label: '周五', value: '6'},
              {label: '周六', value: '7'},]
            if(!value) return
            let weekList=[]
            var date1 = new Date(Date.parse(value[0].replace(/-/g,   "/")));
            var date2 = new Date(Date.parse(value[1].replace(/-/g,   "/")));
            var iDays = parseInt(Math.abs(date2.getTime()- date1.getTime()) /1000/60/60/24); console.log(iDays)
            if(iDays>=7){
                this.weekOptions=[
                {label: '周日', value: '1'},
                {label: '周一', value: '2'}, 
                {label: '周二', value: '3'},
                {label: '周三', value: '4'},
                {label: '周四', value: '5'},
                {label: '周五', value: '6'},
                {label: '周六', value: '7'},]
            }else if (iDays<=0) {
                let indexone=new Date(value[0]).getDay()
                this.weekOptions.forEach((item,index)=>{
                    if(indexone == index){
                    weekList.push(item)
                    }
                })
                this.weekOptions=weekList
            } else {
                let indexone=new Date(value[0]).getDay()
                let indextwo=new Date(value[1]).getDay()
                this.weekOptions.forEach((item,index)=>{
                        if(indexone<indextwo){
                            if(indexone<=index){
                                if(indextwo>=index){
                                    weekList.push(item)
                                }
                            }
                        }else if(indexone>indextwo){
                            if(indexone<=index){
                                weekList.push(item)
                            }else if(indextwo>=index){
                                weekList.push(item)
                            }
                        }
                })
                this.weekOptions=weekList
            }
        },

        selectText(val) {
            if (val === 0) {
                this.priceText = "电费（元/度）"
                this.serviceText = "服务费（元/度）"
            } else if (val === 1) {
                this.priceText = "电费（%）"
                this.serviceText = "服务费（%）"
            }
        },

        //根据价格类别改变电费与服务费，相同的类别同时修改
        changePrice(item, index) {
            console.log("item,index",item,index)
            for (let i = 0; i<this.tableData.length; i++) {
                if (this.tableData[index].priceType === this.tableData[i].priceType) {
                    this.tableData[i].cpoElecMoney = this.tableData[index].cpoElecMoney
                    this.tableData[i].cpoServiceMoney = this.tableData[index].cpoServiceMoney
                }
            }
        },

        getDetail() {
            let data = {
                id: this.id
            }
            this.$store.dispatch("form/handle", {
                url: "/business/discountterm/getUpdateById",
                data: data,
                method: "get",
                callback: resp => {
                    console.log(resp)
                    this.rowdata = resp
                    this.userTree = resp.userNodeList
                    this.tableData = []
                    let dateList = this.rowdata.discountStation[resp.discountTerm.pricingModel]
                    this.discountTree = this.rowdata.stationNodeList[resp.discountTerm.pricingModel]
                    this.cityTree = this.rowdata.stationNodeList[resp.discountTerm.pricingModel]
                    for (let i = 0; i<dateList.length; i++) {
                        this.tableData.push(
                            {
                                priceStartPeriod: dateList[i].priceStartPeriod,
                                priceEndPeriod: dateList[i].priceEndPeriod,
                                cpoElecMoney: dateList[i].cpoElecMoney,
                                cpoServiceMoney: dateList[i].cpoServiceMoney,
                                priceType: dateList[i].priceType,
                                defaultRange: dateList[i].defaultRange
                            }
                        )
                    }
                    this.form.projectName = resp.discountTerm.projectName
                    this.form.responsible = Number(resp.discountTerm.responsible)
                    this.form.operator = resp.discountTerm.operator
                    this.form.date = [resp.discountTerm.discountStartDay, resp.discountTerm.discountEndDay]
                    this.handleChange(this.form.date)
                    this.form.checkList = resp.discountTerm.discountWeek.split(",")
                    this.form.recommend = resp.discountTerm.recommend
                    this.lastform.pricingModel = resp.discountTerm.pricingModel
                    this.lastform.discountType = Number(resp.discountTerm.discountType)
                    this.lastform.discountSiteList = resp.stationIds[resp.discountTerm.pricingModel]
                    this.lastform.userID = resp.accoutIds
              }
            });
        }
    },

    mounted() {
        // this.getStation()
        this.getDetail()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {
        this.id = this.$route.query.data
        console.log("data", this.id)
    }, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>
  
  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

</style>
  


// WEBPACK FOOTER //
// src/views/discount/reviseDiscount.vue